import React from 'react'
import './Header.css';

export const Header = () => {
  return (
    <div className='Header'>
     <div className='Header-child'>

      <div><h3>Home Decor</h3></div>
      
      <div><h3>Products Near me</h3></div>
    </div>
    </div>
  )
}
